import { render, staticRenderFns } from "./all_fj.vue?vue&type=template&id=2a216fb1&scoped=true"
import script from "./all_fj.vue?vue&type=script&lang=js"
export * from "./all_fj.vue?vue&type=script&lang=js"
import style0 from "./all_fj.vue?vue&type=style&index=0&id=2a216fb1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a216fb1",
  null
  
)

export default component.exports